module.exports = __webpack_public_path__ + "static/img/team.6bfbcde.png";


//////////////////
// WEBPACK FOOTER
// ./static/team.png
// module id = WXw7
// module chunks = 0